import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class CustomerInvoiceItemService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('CustomerInvoiceItem');
	}

	loadAllForInvoice(id: System.Guid): Observable<TooBig4Car.Logic.IInvoiceLineItem[]> {
		return this.myBaseService.loadAll(this.url + '/ForInvoice/' + (id || ''));
	}
	loadAllForCustomer(searchVM: TooBig4Car.Logic.DateSearchVM): Observable<TooBig4Car.Logic.CustomerInvoiceArbitraryItem[]> {
		return this.myBaseService.post(searchVM, this.url + '/ForCustomer', true);
	}
	
	save(tempItem: TooBig4Car.Logic.ObjectBase): Observable<TooBig4Car.Logic.IInvoiceLineItem> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid,type:number): Observable<boolean> {
		return this.myBaseService.deleteWithParams(id, this.url, '?type=' + type.toString());
	}
	getEdit(id: System.Guid, type: number): Observable<TooBig4Car.Logic.IInvoiceLineItem> {
		return this.myBaseService.getWithParams(id, this.url + '/Edit', '?type=' + type.toString(), false);
	}
	saveArbitrary(tempItem: TooBig4Car.Logic.CustomerInvoiceArbitraryItem): Observable<TooBig4Car.Logic.CustomerInvoiceArbitraryItem> {
		return this.myBaseService.save(tempItem, this.url + '/ArbitraryItem');
	}

	getArbitraryEdit(id: System.Guid): Observable<TooBig4Car.Logic.CustomerInvoiceArbitraryItem> {
		return this.myBaseService.getEdit(id, this.url + '/ArbitraryItem');
	}
}
